var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaggedAwareness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40947_996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 2.15625C5.05241 2.15625 2.15625 5.05241 2.15625 8.625C2.15625 12.1976 5.05241 15.0938 8.625 15.0938C12.1976 15.0938 15.0938 12.1976 15.0938 8.625C15.0938 5.05241 12.1976 2.15625 8.625 2.15625ZM0.71875 8.625C0.71875 4.2585 4.2585 0.71875 8.625 0.71875C12.9915 0.71875 16.5312 4.2585 16.5312 8.625C16.5312 12.9915 12.9915 16.5312 8.625 16.5312C4.2585 16.5312 0.71875 12.9915 0.71875 8.625ZM5.03125 8.625C5.03125 8.22804 5.35305 7.90625 5.75 7.90625H11.5C11.897 7.90625 12.2188 8.22804 12.2188 8.625C12.2188 9.02195 11.897 9.34375 11.5 9.34375H5.75C5.35305 9.34375 5.03125 9.02195 5.03125 8.625Z",
    fill: "#552E75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40947_996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.25,
    height: 17.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaggedAwareness);
export default __webpack_public_path__ + "static/media/flagged_awareness.943d6976e0796067a56d39958294292d.svg";
export { ForwardRef as ReactComponent };